import React, { useState } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from './../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextAreaComponents from './../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import './AddWholeSaleMenuItemDialog.css'
import AddItemDialogComponent from '../../../AddItemDialog.tsx';
import plusIcon  from './../../../../../../assets/icons/plus.png'


function AddWholeSaleMenuItemDialog(props) {

//dialog start
const [openItemDialog, setOpenItemDialog]=useState(false)

const handleDialogOpen=(name)=>{
    if(name=='item'){
        setOpenItemDialog(true)
    }
}
const handleAddItem=(data)=>{
    setOpenItemDialog(data)
}


//dialog end


    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const sectionDatas = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const [Item, setItem] = React.useState("");
    const addValue = (props) => {
        console.log(props)
        setItem(props)
    }
    const [addons, setAddons] = React.useState([]);
    const addaddons = (props) => {
        console.log(props)
        setAddons(props)
    }
    const saveData = () => {
        const values = {
            ItemName: Item,
            addonsItem: addons,
            quantity: quantity,
            portionSize: portionSize
        }
        props.onHandleAddItem(values)
    }
    const [quantity, setquantity] = React.useState(0);
    const textFieldValue = (props) => {
        console.log(props)
        setquantity(props);
    }
    const [portionSize, setportionSize] = React.useState("");
    const portionSizeValue = (props) => {
        console.log(props)
        setportionSize(props);
    }

    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Add Item in wholesale menu</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container >
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Item Name"}
                                    placeholder={'Item Name'}
                                    value={addValue}
                                    datas={sectionDatas}
                                    id={1}
                                />

                            </Grid>
                            <Grid item xs={1} className="" onClick={()=>handleDialogOpen('item')} >
                                    {/* <img src={plusIcon} alt="+" /> */}
                                    <button className='modalAddButton'>+Add Item</button>
                                </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Addons
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Addons"}
                                    placeholder={'Addons'}
                                    value={addaddons}
                                    datas={sectionDatas}
                                    id={2}
                                />

                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Quantity
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <div className='d-flex'>
                                    <button className={`circleDiv ${quantity === 0 ? "disableMinus" : ""}`} onClick={() => { setquantity(parseInt(quantity) - 1) }}>-</button>
                                    <input type="number" pattern="[0-9]*" className='form-control quantityNumber' value={quantity} onChange={event => { setquantity(event.target.value) }} />
                                    {/* <button className='circleDiv'>{quantity}</button> */}
                                    <button className='circleDiv' onClick={() => { setquantity(parseInt(quantity) + 1) }}>+</button>
                                </div>
                                {/* <TextAreaComponents label={'Quantity'} value={textFieldValue} id={3} min={5} max={100} /> */}
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Portion size
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={' Portion size'} value={portionSizeValue} />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddItemDialogComponent open={openItemDialog} onHandleAddItem={handleAddItem}/>
        </div>
    );
}

export default AddWholeSaleMenuItemDialog;